import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import References from "../../components/References";
import LdsBlockSteps from "../../components/LdsBlockSteps";
import IconSpinner from "../../assets/components/blockStep/icon-spinner-scale.svg";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_2_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.2.2 Step 2: Set the Maximum Intensity of the Black-White Scale
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5 mb-3 ms-3 align-items-center">
            <div className="col-md-3 col-sm-12 mb-4 ">
              <LdsBlockSteps
                steps={[
                  {
                    number: 2,
                    color: "orange",
                    icon: IconSpinner,
                    text: "Set the maximum intensity of the scale to the maximum intensity of all the brain pixels",
                    boxType: "mid",
                  },
                ]}
              />
            </div>
            <div className="col-md-8 col-sm-12 ">
              <ul className="ms-0">
                <li>
                  Set the maximum intensity of the black-white scale to the
                  maximum intensity of all the brain pixels
                </li>
                <li>
                  Initially locate the brain slice with the highest levels of
                  image contrast (highest radioactivity signals for Amyvid
                  uptake) and adjust the contrast appropriately
                </li>
              </ul>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-1", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-3", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>

          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_2_1;
